import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { RootState } from "app/lib/store/store";
import { useDispatch } from "react-redux";
import {
  nextStep,
  prevStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";

import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import ErrorsMessage from "app/components/common/errors/ErrorsMessage";

interface FormData {
  loanFor: string;
}

const PurposeOfLoan: React.FC = () => {
  const dispatch = useDispatch();

  const { loanApplication, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const [selectedLoan, setSelectedLoan] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    const { loanFor } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        loanApplication: {
          ...loanApplication,
          loanFor: loanFor,
        },
      })
    );
    dispatch(nextStep());
  };

  const handleLoanSelect = (loan: string) => {
    setSelectedLoan(loan);
    setValue("loanFor", loan);
    clearErrors("loanFor");
  };

  useEffect(() => {
    if (loanApplication?.loanFor) {
      setSelectedLoan(loanApplication?.loanFor);
      reset({ loanFor: loanApplication?.loanFor });
    }
  }, [loanApplication?.loanFor, reset]);

  return (
    <>
      <ProgressBar progress={0} MB={10} />
      <div className="w-full  sm:w-[70%] xl:w-[40%]  mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Purpose of Loan" />
        <SubTitle title="Please select an option below" />

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="text-left mb-4">
            <h6 className="font-Mulish hidden text-nowrap text-base text-lightBlue">
              Loan Purpose
            </h6>
          </div>
          <div className="mb-10">
            <div className="w-full flex justify-between gap-4 sm:gap-10 mb-3 ">
              <div
                className={`w-full flex gap-5 justify-center font-Mulish text-[14px] items-center h-[50px] sm:h-[55px] transition-colors duration-300 rounded-[10px] cursor-pointer 
                ${
                  selectedLoan === "personal"
                    ? "bg-primary text-white"
                    : "bg-grey hover:bg-primary hover:text-white"
                }`}
                onClick={() => handleLoanSelect("personal")}
              >
                Personal Use
              </div>
              <div
                className={`w-full flex gap-5  justify-center font-Mulish  text-[14px] items-center h-[50px]  sm:h-[55px] transition-colors duration-300 rounded-[10px] cursor-pointer ${
                  selectedLoan === "business"
                    ? "bg-primary text-white"
                    : "bg-grey hover:bg-primary hover:text-white"
                }`}
                onClick={() => handleLoanSelect("business")}
              >
                Business Use
              </div>
              <input
                type="hidden"
                {...register("loanFor", {
                  required: "Please select a Purpose of loan.",
                })}
              />
            </div>
            {errors.loanFor && <ErrorsMessage title={errors.loanFor.message} />}
          </div>
          <div className="flex justify-between">
            <PreviousButtom onClick={() => dispatch(prevStep())}>
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PurposeOfLoan;
